import { Component } from "react";
import Toolbar from "../components/toolbar";
import { collection, deleteDoc, getDocs, orderBy, query, updateDoc } from "firebase/firestore/lite";
import { dbPublic } from "../../App";
import { IoEye } from "react-icons/io5";
import { FaTrash } from "react-icons/fa";
import { CgCloseO } from "react-icons/cg";

class ContactUs extends Component<any,any> {

    constructor(props:any) {
        super(props);
        this.state = {
            contacts: [],
            contact: {},
            viewing: false,
        }
    }

    async componentDidMount() {
            var tCol = collection(dbPublic,'contact');
            var tSnap = await getDocs(query(tCol,orderBy("isRead",'asc'), orderBy("date",'desc')));
            this.setState({contacts: tSnap.docs});
        }

    render() {

        return (
            <div style={{height: '100%', fontFamily: 'avenir'}}>
                <Toolbar />
                <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                    <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                        CONTACT US ENTRIES
                    </div>
                    <div>
                        <div style={{fontFamily: 'avenirb'}}></div>
                        View or Export newsletter signups<br/><br/>
                        There are currently {this.state.contacts.length} contact us entries.<br/><br/>
                        
                    </div>
                    <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                        <div style={{width: '150px'}}><b>Date</b></div>
                        <div style={{width: '200px'}}><b>Name</b></div>
                        <div style={{width: '200px'}}><b>Email</b></div>
                        <div style={{width: '150px'}}><b>Phone</b></div>
                        <div style={{width: '200px'}}><b>Subject</b></div>
                        {/* <div style={{width: '400px'}}><b>Message</b></div> */}
                        <div style={{width: '100px'}}><b></b></div>
                    </div>
                    {this.state.contacts.map((contact:any,i:number)=>{
                        var c = contact.data();
                        return (
                            <div style={{display: 'flex',borderBottom: '1px dotted #000', fontSize: '10pt', paddingTop: '5px', paddingBottom: '5px', backgroundColor: c.isRead == false ? 'rgba(200,0,0,.2)' : 'rgba(255,255,255,1)', fontFamily: c.isRead == false ? 'avenirb' : 'avenir'}}>
                                <div style={{width: '150px'}}><b>{new Date(c.date.seconds * 1000).toLocaleString()}</b></div>
                                <div style={{width: '200px'}}><b>{c.name}</b></div>
                                <div style={{width: '200px'}}><b>{c.email}</b></div>
                                <div style={{width: '150px'}}><b>{c.phone}</b></div>
                                <div style={{width: '200px'}}><b>{c.subject}</b></div>
                                {/* <div style={{width: '400px'}}><b>Message</b></div> */}
                                <div style={{width: '100px'}}><b>
                                    

                                    <IoEye size={25} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(0,200,0,1)'}} onClick={async ()=>{
                                        updateDoc(contact.ref,{isRead: true});
                                        this.setState({viewing: true, contact: contact});
                                    }}/>

                                    <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                        var tCol = collection(dbPublic,'contact');
                                        await deleteDoc(contact.ref);
                                        var tSnap = await getDocs(query(tCol,orderBy("isRead",'asc'), orderBy("date",'desc')));
                                        this.setState({contacts: tSnap.docs});
                                    }}/>
                                    </b>
                                </div>
                            </div>
                        )
                    })}
                    {this.state.viewing ? 
                        <div className="overlay">
                            <div className="window">
                                <div className="closeWindow" onClick={async ()=>{
                                    var tCol = collection(dbPublic,'contact');
                                    getDocs(query(tCol,orderBy("isRead",'asc'), orderBy("date",'desc'))).then(tSnap => {
                                        this.setState({viewing: false, contact: {},contacts: tSnap.docs});
                                    });
                                    
                                }}>
                                    <CgCloseO />
                                </div>
                                <div className="windowTitle">
                                    VIEW CONTACT DETAILS
                                </div>
                                <div style={{height: 400, overflowY: 'auto', overflowX: 'hidden'}}>
                                    <div><b>Date:</b> {new Date(this.state.contact.data().date.seconds * 1000).toLocaleString()}</div>
                                    <div><b>Name:</b> {this.state.contact.data().name}</div>
                                    <div><b>Email:</b> {this.state.contact.data().email}</div>
                                    <div><b>Phone:</b> {this.state.contact.data().phone}</div><br/>
                                    <div><b>Subject:</b> {this.state.contact.data().subject}</div>
                                    <div><b></b><br/> {this.state.contact.data().message}</div>
                                </div>
                            </div>
                        </div>
                    : null}
                </section>
            </div>
        )
    }

}

export default ContactUs;